import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormat',
})
export class CurrencyFormatPipe implements PipeTransform {
  transform(value: any, currency?: string, decimals: number = 2): string {
    const isNullOrUndefined = (value: any) => {
      return value === null || value === undefined;
    };

    if (isNullOrUndefined(value)) {
      const zeroValue = (0).toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });

      return currency ? `${currency} ${zeroValue}` : zeroValue;
    }

    if (Number.isNaN(Number(value))) {
      return value;
    }

    const numero = Number(value).toFixed(decimals);

    const numeroFormateado = Number(numero).toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });

    if (currency) {
      return `${currency} ${numeroFormateado}`;
    }
    return numeroFormateado;
  }
}
